package com.upcominds.expedite.data.auth

import kotlinx.serialization.Serializable

@Serializable
data class TokenSet(
    val accessToken: String,
    val refreshToken: String?,
    val idToken: String?,
    val expiresAtEpochSeconds: Long
)
